/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsSessionTimedOut } from 'modules/dashboard/selectors';
import { authActions } from 'modules/common/auth/slice';
import { faroSendHotelBasedUserActivity } from 'modules/common/utils/faro';
import calculateActiveUserTime from 'modules/common/utils/active-user-time';
import { useEffect } from 'react';
/**
 * Pop up common component that uses across modules for display session timeout messages
 */
const SessionTimeOutPopup = () => {
  const dispatch = useDispatch();
  const isSessionTimedOut = useSelector(selectIsSessionTimedOut);
  //
  useEffect(() => {
    if (isSessionTimedOut) {
      faroSendHotelBasedUserActivity(null, true);
    }
  }, [isSessionTimedOut]);
  //
  return (
    <Dialog
      open={isSessionTimedOut}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{ borderRadius: 50 }}
    >
      <DialogTitle id="alert-dialog-title" sx={{ textAlign: 'center' }}>
        Session Expired!
      </DialogTitle>
      <DialogContent id="alert-dialog-description" sx={{ textAlign: 'center', mx: 10 }}>
        Your session has expired. Please login again to continue working.
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: 'space-around',
          pb: 5,
        }}
      >
        <Button
          sx={{ px: 10 }}
          autoFocus
          variant="contained"
          onClick={() => {
            // sign out clears tokens, which redirects to login and re-initiates the auth flow
            calculateActiveUserTime();
            dispatch(authActions.signOut());
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
//
export default SessionTimeOutPopup;
